import {Controller} from '@hotwired/stimulus';

/**
 * Choisit une vignette par défaut d'un sélecteur à vignettes dont le champ arrive vide.
 *
 *   <div {{ stimulus_controller('image-choice-default', {field: form.disposition.vars.name, choice: 'liste'}) }}>
 *     {{ macros.form_text_image_simple(form.disposition, form) }}
 *   </div>
 *
 * Le bloc contient le champ caché d'id `field` et les vignettes `.<field>_button`, chacune avec sa
 * valeur en `data-value`. Si le champ est vide, la vignette de valeur `choice` (à défaut, la
 * première) prend la classe `selected`, les autres la perdent, et sa valeur est écrite dans le champ.
 * Aucun clic n'est simulé.
 *
 * Avec `replace: true`, la vignette par défaut remplace aussi une valeur déjà présente : une
 * disposition qui ne suit pas un type d'affichage arrivé vide.
 */
export default class extends Controller {
  static values = {
    field: String,
    choice: String,
    replace: Boolean,
  };

  connect() {
    const field = CSS.escape(this.fieldValue);
    const input = this.element.querySelector(`input[type="hidden"]#${field}`);

    if (input === null || (input.value !== '' && !this.replaceValue)) {
      return;
    }

    const buttons = [...this.element.querySelectorAll(`.${field}_button`)];
    const chosen = buttons.find((button) => button.dataset.value === this.choiceValue) ?? buttons[0];

    if (chosen === undefined) {
      return;
    }

    buttons.forEach((button) => button.classList.toggle('selected', button === chosen));
    input.value = chosen.dataset.value;
  }
}
